<template>
  <div class="new-page-con">
    <Header @onSearch="onSearch">
      <!-- 工具栏 -->
      <Tollbar
        :list="tollbarList"
        :sortList="sortList"
        :conditionsList="conditionsList"
        :selectList="selectList"
        type="0"
        theme="0"
        :isShowSearch.sync="isShowSearch"
        :isShowSelect.sync="isShowSelect"
        @onClearSearch="onClearSearch"
        @onChangeSort="onChangeSort"
      ></Tollbar>
    </Header>
    <div class="new-content-con">
      <!-- 检索条件 -->
      <div
        class="new-search-con"
        :class="{ 'new-content-none-search': !isShowSearch }"
        v-loading="loadingSearch"
      >
        <span class="clear-search-icon" @click="onClearSearch"
          ><i class="iconfont icon-qingchu"></i> Clear All</span
        >
        <el-form
          ref="searchForm"
          label-position="top"
          :model="searchForm"
          class="new-content-search"
        >
          <!-- 日期 -->
          <el-form-item :label=" $t('MyDatabase.Date') " prop="publishTime">
            <el-select
              v-model="searchForm.publishTime"
              clearable
              filterable
              class="search-select-con"
              popper-class="new-search-select"
              placeholder="By Date"
              @change="onChangeParams"
            >
              <el-option
                v-for="item in conditions.timeList"
                :key="item.code"
                :label="item.valueEn"
                :value="item.code"
              >
                <div class="flex-between-center">
                  <span class="select-name">{{ item.valueEn }}</span>
                  <span class="select-num">{{
                    item.dateCount | FilterNum
                  }}</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 公司名称 -->
          <el-form-item :label="$t('MyDatabase.CompanyName')" prop="companyNameEn">
            <el-select
              v-model="searchForm.companyNameEn"
              clearable
              filterable
              class="search-select-con"
              popper-class="new-search-select"
              placeholder="Select Company Name"
              @change="onChangeParams"
            >
              <el-option
                v-for="item in conditions.companyNameList"
                :key="item.code"
                :label="item.valueEn"
                :value="item.code"
              >
                <div class="flex-between-center">
                  <el-tooltip
                    effect="light"
                    :visible-arrow="false"
                    :disabled="item.valueEn.length < 25"
                    :content="item.valueEn"
                    placement="right"
                  >
                    <span class="select-name">{{ item.valueEn }}</span>
                  </el-tooltip>

                  <span class="select-num">{{
                    item.dateCount | FilterNum
                  }}</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 行业 -->
          <el-form-item label="Industry" prop="industry">
            <el-select
              v-model="searchForm.industry"
              clearable
              filterable
              class="search-select-con"
              popper-class="new-search-select"
              placeholder="Select Industry"
              @change="onChangeParams"
            >
              <el-option
                v-for="item in conditions.industryList"
                :key="item.code"
                :label="item.valueEn"
                :value="item.code"
              >
                <div class="flex-between-center">
                  <el-tooltip
                    effect="light"
                    :visible-arrow="false"
                    :disabled="item.valueEn.length < 25"
                    :content="item.valueEn"
                    placement="right"
                  >
                    <span class="select-name">{{ item.valueEn }}</span>
                  </el-tooltip>
                  <span class="select-num">{{
                    item.dateCount | FilterNum
                  }}</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 主题 -->
          <el-form-item label="Subjects" prop="subjectCodeList">
            <el-select
              v-model="searchForm.subjectCodeList"
              clearable
              filterable
              class="search-select-con"
              popper-class="new-search-select"
              placeholder="Select Subjects"
              @change="onChangeParams"
            >
              <el-option
                v-for="item in conditions.subjectList"
                :key="item.code"
                :label="item.valueEn"
                :value="item.code"
              >
                <div class="flex-between-center">
                  <el-tooltip
                    effect="light"
                    :visible-arrow="false"
                    :disabled="item.valueEn.length < 25"
                    :content="item.valueEn"
                    placement="right"
                  >
                    <span class="select-name">{{ item.valueEn }}</span>
                  </el-tooltip>
                  <span class="select-num">{{
                    item.dateCount | FilterNum
                  }}</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 类型 -->
          <el-form-item label="News Type" prop="sourceGenre">
            <el-select
              v-model="searchForm.sourceGenre"
              clearable
              filterable
              class="search-select-con"
              popper-class="new-search-select"
              placeholder="Select News Type"
              @change="onChangeParams"
            >
              <el-option
                v-for="item in conditions.typeList"
                :key="item.code"
                :label="item.valueEn"
                :value="item.code"
              >
                <div class="flex-between-center">
                  <el-tooltip
                    effect="light"
                    :visible-arrow="false"
                    :disabled="item.valueEn.length < 25"
                    :content="item.valueEn"
                    placement="right"
                  >
                    <span class="select-name">{{ item.valueEn }}</span>
                  </el-tooltip>
                  <span class="select-num">{{
                    item.dateCount | FilterNum
                  }}</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <!-- 列表 -->
      <div class="new-content-right">
        <div class="new-content-total">
          Found over {{ total | FilterNum }} “{{ $route.query.keyword }}”
          results
        </div>
        <div class="new-table-box" v-loading="loading">
          <el-table
            :data="tableData"
            row-key="index"
            class="new-table-con"
            height="100%"
            v-loadmore="handleScroll"
            @selection-change="onChangeSelection"
          >
            <el-table-column
              type="selection"
              reserve-selection
              :width="isShowSelect ? 40 : 10"
              align="right"
            >
            </el-table-column>
            <el-table-column
              prop="date"
             :label=" $t('MyDatabase.Date') "
              width="150"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="titleEn"
              label="Title"
              min-width="300"
              class-name="hover-cell"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span
                  v-if="scope.row.id || scope.row.link"
                  class="link-text hover-text"
                  @click="getPdfLink(scope.row)"
                  >{{ scope.row.titleEn }}</span
                >
                <span v-else>{{ scope.row.titleEn }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="sourceEn"
              label="Source"
              width="320"
              show-overflow-tooltip
            >
            </el-table-column>
            <!-- 
              影响度 国内的是emotionlabel 1和3是绿色 2是红色
              国际的是1和2绿色 3红色
            -->
            <el-table-column
              prop="emotionLabel"
              label="Impact"
              width="140"
              align="center"
            >
              <template slot-scope="scope">
                <template
                  v-if="
                    (scope.row.id && scope.row.emotionLabel == '3') ||
                    (!scope.row.id && scope.row.emotionLabel == '2')
                  "
                >
                  <el-tooltip
                    content="Negative"
                    placement="top"
                    effect="light"
                    :visible-arrow="false"
                  >
                    <el-button class="new-tip-icon new-tip-red-icon">
                      <i class="iconfont icon-dianzan2"></i
                    ></el-button>
                  </el-tooltip>
                </template>
                <template v-else>
                  <el-tooltip
                    content="Positive"
                    placement="top"
                    effect="light"
                    :visible-arrow="false"
                  >
                    <el-button class="new-tip-icon new-tip-green-icon"
                      ><i class="iconfont icon-dianzan3"></i
                    ></el-button>
                  </el-tooltip>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <Tips :dialogVisible.sync="isShowTips"></Tips>
  </div>
</template>
<script>
import Header from "@/views/newLayout/header.vue";
import Tollbar from "@/views/newLayout/tollbar.vue";
import Tips from "@/views/newLayout/tips.vue";
import {
  searchNews,
  searchNewsConditions,
  searchNewsFromLoca,
} from "@/api/newApi.js";
import { getPdfLink } from "@/api/companyApi";
import crypto from "@/utils/crypto";
export default {
  directives: {
    loadmore: {
      bind(el, binding) {
        const selectWrap = el.querySelector(".el-table__body-wrapper");
        selectWrap.addEventListener("scroll", function () {
          const scrollDistance =
            this.scrollHeight - this.scrollTop - this.clientHeight;
          if (scrollDistance <= 0.5) {
            binding.value(); // 执行绑定的函数
          }
        });
      },
    },
  },
  components: {
    Header,
    Tollbar,
    Tips,
  },
  data() {
    return {
      isShowTips: false,
      isLogin: false,
      tollbarList: [
        {
          icon: "icon-youhua",
          name: "Optimize",
          disabled: true,
        },
        {
          icon: "icon-xuanze",
          name: "Select",
          disabled: true,
        },
        {
          icon: "icon-bianji1",
          name: "Edit",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-filter",
          name: "Sort by",
          disabled: false,
          select: true,
        },
        {
          icon: "icon-shoucang1",
          name: "Collect",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-baocun",
          name: "Saved",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-icon_xinyong_xianxing_jijin-307",
          name: "Compare",
          disabled: true,
        },
        {
          icon: "icon-daochu04",
          name: "Export",
          disabled: true,
        },
        {
          icon: "icon-xiazai",
          name: "Download",
          disabled: true,
        },
        {
          icon: "icon-shuaxin",
          name: "Update",
          disabled: true,
        },
        {
          icon: "icon-judan",
          name: "Report Error",
          disabled: true,
        },
        {
          icon: "icon-gudong",
          name: "Share",
          disabled: true,
        },
      ],
      sortList: [
        {
          value: "",
          label: "Default",
        },
        {
          value: "2",
          label: "Ascending",
          // children: [
          //   {
          //     value: "2-1",
          //     label: "Date",
          //   },
          //   {
          //     value: "2-2",
          //     label: "Title",
          //   },
          //   {
          //     value: "2-3",
          //     label: "Source",
          //   },
          //   {
          //     value: "2-4",
          //     label: "Impact",
          //   },
          // ],
        },
        {
          value: "1",
          label: "Descending",
          // children: [
          //   {
          //     value: "3-1",
          //     label: "Date",
          //   },
          //   {
          //     value: "3-2",
          //     label: "Title",
          //   },
          //   {
          //     value: "3-3",
          //     label: "Source",
          //   },
          //   {
          //     value: "3-4",
          //     label: "Impact",
          //   },
          // ],
        },
      ],
      conditionsList: ["Date", "Title", "Source", "Impact"],
      searchForm: {
        publishTime: "",
        companyNameEn: "",
        industry: "",
        subjectCodeList: "",
        sourceGenre: "",
        sortCode: "",
      },
      props: {
        checkStrictly: true,
        value: "dictDataCode",
        label: "dictDataName",
      },
      conditions: {
        timeList: [],
        companyNameList: [],
        industryList: [],
        subjectList: [],
        typeList: [],
      },
      tableData: [], // 表格数据
      isShowSearch: true,
      isShowSelect: false, // 是否显示复选框
      selectList: [],
      params: {
        page: 1, // 当前页数
        pageSize: 100, // 每页加载的数据条数
      },
      total: 0,
      loading: false, // 加载状态
      hasMore: true, // 是否还有更多数据
      loadingSearch: false,
      countryList: [],
      userInfo: JSON.parse(localStorage.getItem("userInfo"))
        ? JSON.parse(localStorage.getItem("userInfo"))
        : null,
    };
  },
  mounted() {
    this.countryList = JSON.parse(localStorage.getItem("countryList"));
    if (this.$route.query.keyword) {
      this.params.page = 1;
      this.tableData = [];
      this.getNewsConditions();
      this.getNewsList();
    } else {
      this.params.page = 1;
      this.tableData = [];
      this.getNewsConditions();
      this.searchNewsEmptyList();
    }
  },
  methods: {
    countryCodeToCode(countryCode) {
      let res = "";
      this.countryList.map((item) => {
        item.countryList.map((itemC) => {
          if (countryCode === itemC.countryCode) {
            res = itemC.dowjonesCountrycode;
          }
        });
      });
      return res;
    },
    getPdfLink(row) {
      if (this.userInfo) {
        const userType = this.userInfo?.userInfo?.userType;
        const lockType = this.userInfo?.lockType;
        if (
          (userType == 1 && lockType == 2) ||
          userType == 2 ||
          userType == 3
        ) {
          if (!row.link && row.id) {
            getPdfLink({ articleRef: row.id }).then((res) => {
              if (res.data.includes("http")) {
                let routeData = res.data;
                window.open(routeData, "_blank");
              } else {
                let routeData = "http://" + res.data;
                window.open(routeData, "_blank");
              }
            });
          } else if (row.link && !row.id) {
            if (row.link.includes("http")) {
              let routeData = row.link;
              window.open(routeData, "_blank");
            } else {
              let routeData = "http://" + row.link;
              window.open(routeData, "_blank");
            }
          } else {
          }
        } else {
          this.isShowTips = true;
        }
      }
    },
    onChangeParams() {
      this.params.page = 1;
      this.tableData = [];
      this.getNewsConditions();
      this.getNewsList();
    },
    async getNewsList() {
      this.loading = true;
      let {
        publishTime,
        companyNameEn,
        industry,
        subjectCodeList,
        sourceGenre,
        sortCode,
      } = this.searchForm;
      let res = await searchNews({
        page: this.params.page,
        pageSize: this.params.pageSize,
        title: this.$route.query.keyword,
        countryCode: this.countryCodeToCode(this.$route.query.selectCode),
        sortCode: "",
        publishTime,
        companyNameEn,
        industry,
        subjectCodeList,
        sourceGenre,
        sortCode,
      });
      console.log(
        "getNewsList",
        this.params.page,
        JSON.parse(crypto.decrypt(res))
      );
      let data = JSON.parse(crypto.decrypt(res)).data;
      this.loading = false;
      if (data) {
        let list = data.rows.map((item, index) => {
          return {
            ...item,
            index: (this.params.page - 1) * this.params.pageSize + (index + 1),
          };
        });
        this.tableData = [...this.tableData, ...list];
        this.total = data.total;
      } else {
        this.params.page -= 1;
      }
    },
    async searchNewsEmptyList() {
      this.loading = true;
      let res = await searchNewsFromLoca({
        countryCode: this.countryCodeToCode(this.$route.query.selectCode),
        optionType: 2,
      });
      this.tableData = res.data.rows || [];
      this.total = res.data.rowCount;
      this.loading = false;
    },
    async getNewsConditions() {
      this.loadingSearch = true;
      let {
        publishTime,
        companyNameEn,
        industry,
        subjectCodeList,
        sourceGenre,
        sortCode,
      } = this.searchForm;
      let res = await searchNewsConditions({
        page: 1,
        pageSize: 10,
        title: this.$route.query.keyword,
        countryCode: this.countryCodeToCode(this.$route.query.selectCode),
        sortCode: "",
        publishTime,
        companyNameEn,
        industry,
        subjectCodeList,
        sourceGenre,
        sortCode,
      });
      console.log("getNewsConditions", JSON.parse(crypto.decrypt(res)));
      let data = JSON.parse(crypto.decrypt(res)).data;
      this.loadingSearch = false;
      if (data) {
        this.conditions.timeList = data.timeList ? data.timeList : [];
        this.conditions.companyNameList = data.companyNameList
          ? data.companyNameList
          : [];
        this.conditions.industryList = data.industryList
          ? data.industryList
          : [];
        this.conditions.subjectList = data.subjectList ? data.subjectList : [];
        this.conditions.typeList = data.typeList ? data.typeList : [];
      }
    },
    onChangeSelection(val) {
      console.log("val", val);
      this.selectList = val;
    },
    onClearSearch() {
      this.$refs["searchForm"].resetFields();
      this.searchForm.sortCode = "";
      this.params.page = 1;
      this.tableData = [];
      this.getNewsConditions();
      this.getNewsList();
    },
    onChangeSort(e) {
      console.log("onChangeSort", e);
      this.searchForm.sortCode = e.length > 0 ? e[0] : "";
      if (this.$route.query.keyword) {
        this.params.page = 1;
        this.tableData = [];
        this.getNewsConditions();
        this.getNewsList();
      }
    },
    // 搜索
    onSearch(params) {
      // 参数不同时进行路由替换，否则会报错
      if (
        params.searchKeyword != this.$route.query.keyword ||
        params.selectCode != this.$route.query.selectCode
      ) {
        this.$store.dispatch("app/SetlabelCode", "");
        this.$store.dispatch("app/SetlabelCodeName", "");
        this.$store.dispatch("app/SetarchagAin", true);
        this.$store.commit("setRefreshKey", new Date().getTime());
        this.$router.replace({
          path: "/news/list",
          query: {
            selectCode: params.selectCode ? params.selectCode : "",
            keyword: params.searchKeyword,
          },
        });
      }
      // 调用检索api
      console.log("params", params, this.$route.query);
      if (this.$route.query.keyword) {
        this.params.page = 1;
        this.tableData = [];
        this.getNewsConditions();
        this.getNewsList();
      } else {
        this.$message({
          message: "Enter Keyword",
          center: true,
          type: "error",
        });
      }
    },
    // 表格滚动
    handleScroll() {
      if (this.hasMore && !this.loading) {
        this.loadData();
      }
    },
    // 加载数据
    loadData() {
      let totalPage = Math.ceil(this.total / this.params.pageSize);
      if (this.params.page == totalPage) {
        this.hasMore = false;
      } else {
        this.params.page += 1;
        this.getNewsList();
      }
    },
  },
};
</script>
